import type React from "react";
import { ReactComponent as Svg } from "./assets/plus-18.svg";
import * as styles from "./Icon.module.scss";

type Plus18Props = React.SVGProps<SVGSVGElement>;

export const Plus18 = ({ className, ...props }: Plus18Props) => (
  <Svg className={className ?? styles.base} {...props} />
);
